angular.module("riepilogoPrivacy.components",[])
.component("riepilogoPrivacy",{
    templateUrl: 'ng/components/riepilogoEControllo/riepilogoPrivacy/riepilogoPrivacy.view.html',
    bindings:{
        model:'<',
        riUserG: '<',
        verifica:'=',
        readOnly:'<'
    },
    controller: RiepilogoPrivacy,
    controllerAs: 'riepilogoPrivacyCtrl'
})

function RiepilogoPrivacy(
    $privacyService,
    $configService
){
    var self = this;

    self.$onInit = function(){

        checkPrivacy()
    }

    var checkPrivacy = function(){
        $privacyService.getPrivacyDataDigital(self.riUserG.cf, self.riUserG.piva, self.riUserG.formaGiuridica)
          .then(function (response) {

            self.model.valid = response.privacy.valid && !self.model.dataSottoscrizione;
            if(self.model.valid){
                self.model.validFrom = response.privacy.validFrom;
            }else{
                self.model.validFrom= self.model.dataSottoscrizione;
            }
          })
          .catch(function (error) {
            console.log("errore nella chiamata al servizio delle domande della privacy", error);
          })
    }

    self.check = function(el){
        el.selected = !el.selected;
        if(el.selected){
            el.ndg= $configService.getUser().ndg;
            el.identifier= $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        }else{
            el.ndg= "";
            el.identifier= "";
            el.dataConferma = "";
        }
    }


}